import { useIntl } from 'react-intl';

import { Loader } from '@calm-web/design-system';

import useDiscountedPricing from '@/hooks/api/useDiscountedPricing';

import StripeElements from '../StripeElements';
import { CompanyFormFields, InfoFormFields, TeamsPageName } from '../types';
import messages from './messages';
import PaymentForm from './PaymentForm';
import { Container, Header } from './styles';

export interface PaymentWithPaymentElementProps {
	selectedCoveredLives: number;
	infoPageFields: InfoFormFields;
	companyPageFields: CompanyFormFields;
	setActivePage: (page: TeamsPageName) => Promise<void>;
	coupon?: string;
}

const PaymentWithPaymentElement: React.FC<PaymentWithPaymentElementProps> = ({
	selectedCoveredLives,
	infoPageFields,
	companyPageFields,
	setActivePage,
	coupon,
}) => {
	const { formatMessage } = useIntl();
	const discountedPricing = useDiscountedPricing(selectedCoveredLives);

	return (
		<Container data-testid="stripe-payment-element-checkout">
			{/*
			 TO DO: Better error handling on error. Atm, error banner flashes
			 and then disappears (dispatched in useDiscountedPricing hook)
			*/}
			{discountedPricing.loading || discountedPricing.error ? (
				<Loader color="gray1" />
			) : (
				<>
					<Header>{formatMessage(messages.header)}</Header>
					<StripeElements amount={discountedPricing?.totalCost!} mode="subscription">
						<PaymentForm
							discountedPricing={discountedPricing}
							selectedCoveredLives={selectedCoveredLives}
							infoPageFields={infoPageFields}
							companyPageFields={companyPageFields}
							setActivePage={setActivePage}
							coupon={coupon}
						/>
					</StripeElements>
				</>
			)}
		</Container>
	);
};

export default PaymentWithPaymentElement;
